type UploadBody = Blob | string | ArrayBuffer | ArrayBufferView | Uint8Array

const accessKeyId = null
const bucketName = null
const region = null
const secretAccessKey = null

export const s3Upload = async (Key: string, Body: UploadBody): Promise<string> => {
    void Body

    if (!accessKeyId || !bucketName || !region || !secretAccessKey) {
        throw new Error('Missing s3Upload environment variables')
    }

    return `https://${bucketName}.s3.${region}.amazonaws.com/${Key}`
}
